import { j as o } from "../../../jsx-runtime-c20f6c15.mjs";
import { OrderFormat as e } from "@ancon/wildcat-types";
import m from "clsx";
import c from "../../../shared/icons/delivery-outline.svg.mjs";
import l from "../../../shared/icons/delivery-fill.svg.mjs";
import p from "../../../shared/icons/paper-bag-outline.svg.mjs";
import s from "../../../shared/icons/takeaway-fill.svg.mjs";
import u from "../../../shared/icons/table-order-outline.svg.mjs";
import f from "../../../shared/icons/eat-in-outline.svg.mjs";
import v from "../../../shared/icons/eat-in-fill.svg.mjs";
import g from "../../../shared/icons/box-pickup-order-outline.svg.mjs";
import "react";
const O = "_container_1phii_1", d = {
  container: O
};
function y(t, r = !1) {
  switch (t) {
    case e.Delivery:
      return r ? l : c;
    case e.TakeAway:
      return r ? s : p;
    case e.TableOrder:
      return u;
    case e.BoxPickup:
      return g;
    default:
      return r ? v : f;
  }
}
function b({
  orderFormat: t,
  size: r = 40,
  filled: i = !1,
  className: n
}) {
  const a = y(t, i);
  return /* @__PURE__ */ o("div", { className: m(d.container, n), children: /* @__PURE__ */ o(a, { height: r / 2, width: r / 2 }) });
}
export {
  b as default
};
